import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Typography } from 'antd'

//style
import './index.css'
import typo from "../../constants/dictionaries";

const { Title } = Typography;

// Components
const TNN = lazy(() => import('./TNN'))
const DTM = lazy(() => import('./DTM'))
const BVMT = lazy(() => import('./BVMT'))
const DNCP = lazy(() => import('./DeNghiCapNhatCP'))
const ThongKe = lazy(() => import('./ThongKe'))

export default ({ match }) => {
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/TNN`} component={TNN} />
        <Route exact path={`${match.path}/DTM`} component={DTM} />
        <Route exact path={`${match.path}/BVMT`} component={BVMT} />
        <Route exact path={`${match.path}/CNCP`} component={DNCP} />
        <Route exact path={`${match.path}/thongke`} component={ThongKe} />
      </Switch>
    </Suspense>
  )
}